import { createStore } from "solid-js/store";
import type { IChatGptModes } from "~/solidJs/entities/ChatGptEntities/ChatGptMainLayout";
import type { MessageState } from "~/solidJs/shared/helpers/types";
/**
 * store containing all gpt inforamtion eg messages for all modes, active sending mode
 */
export type ChatGptModeStateStore = Record<
	IChatGptModes,
	{
		isHintVisible: boolean;
		error: string | null;
	} & MessageState
> & {
	mode: IChatGptModes;
};
export const cretechatGptModesStateStore = () => {
	const [getChatGptModesStateStore, setChatGptModesStateStore] =
		createStore<ChatGptModeStateStore>({
			assistant: {
				isHintVisible: true,
				messages: [],
				isPending: false,
				error: null
			},
			dialog: {
				isHintVisible: true,
				messages: [],
				isPending: false,
				error: null
			},
			promptGeneration: {
				isHintVisible: true,
				messages: [],
				isPending: false,
				error: null
			},
			mode: "assistant"
		});
	return {
		getChatGptModesStateStore,
		setChatGptModesStateStore
	};
};
